import React, { useEffect } from "react";
import { useImmer } from "use-immer";
import { successMessage, errorMessage } from "../../../utils";
import { useAppConfig, usePermission } from "../../../shared";
import { getOnlineOrderingSettings, updateOnlineOrderingSettings } from "../api/onlineOrderingApi";

export const useOnlineOrderingSettings = () => {
  const isEditable = usePermission("integration-modify");
  const { taxTerm } = useAppConfig();
  const [state, setState] = useImmer({
    isBusy: false,
    initialLoad: true,
    details: {
      status: false,
      fee_type: null,
      value: 0,
      fee_info: "Service fee for using stripe",
      fee_title: `Stipe Customer Fee(exc ${taxTerm})`
    },
    isSaveButtonBusy: true,
  });


  const handleGetSettingsDetails = async () => {
    try {
      const res = await getOnlineOrderingSettings();

      if (res.success) {
        setState((draft) => {
          draft.details = {
            ...res.data,
            fee_type: res.data.fee_type || "percentage"
          };
          draft.initialLoad = false;
          draft.isSaveButtonBusy = true;
        });
      } else {
        errorMessage(res.message);
      }
    } catch (error) {
      errorMessage(error.message);
    }
  };

  useEffect(() => {
    if (state.initialLoad) {
      handleGetSettingsDetails();
    }
  }, [state.initialLoad]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((draft) => {
      draft.details[name] = value;
      draft.isSaveButtonBusy = false;
    });
  };

  const handleSubmit = async (e) => {

    setState((draft) => {
      draft.isSaveButtonBusy = true;
    });

    try {

      let payload = {
        stripe_customer_fee: state.details
      };

      const res = await updateOnlineOrderingSettings(payload);
      if (res.success) {
        successMessage(res.message);
      } else {
        errorMessage(res.message);
        setState((draft) => {
          draft.isSaveButtonBusy = false;
        });
      }
    } catch (error) {
      errorMessage(error.message);
      setState((draft) => {
        draft.isSaveButtonBusy = false;
      });

    }
  }


  return {
    state,
    handleInputChange,
    handleSubmit,
    isEditable,
  };
};
